import { ShortlistWithScores } from "PFApp/components/resource_table_toggle/hooks/use_shortlist_items";

import { PercentageValue } from "../../../percentage_value";

type AvailabilityCellProps = {
  shortlist: ShortlistWithScores;
};

export const AvailabilityCell = ({ shortlist }: AvailabilityCellProps) => (
  <PercentageValue value={shortlist.scores?.availabilityScore} />
);
